// Based on .env VITE_ENV_MODE
export const PRODUCTION_ENVS = ["staging", "platform"];
export const TEST_STAGING_ENV_MODE = "test";
export const TEST_DEV_ENV_MODE = "test-dev";
export const DEV_ENV_MODE = "development";

export type FlagName =
  | "FEATURE_TOUR"
  | "INCIDENTS_V3"
  | "DASHBOARD_OVERVIEW_CUSTOMER"
  | "PHS_CUSTOMER_SEND_TEST_LURE"
  | "SAT_CONTENT_MANAGER"
  | "SAT_CUSTOMER_REPORT_MANAGER"
  | "RBAC"
  | "ADMIN_SET_SYSTEM_ADMIN_ROLE"
  | "NEW_EDIT_ADMIN_MODAL"
  | "SEG";

type Config = {
  [K in FlagName]: {
    dev: boolean;
    testDev: boolean;
    testStaging: boolean;
    prod: boolean;
  };
};

export const FLAGS_CONFIG: Config = {
  FEATURE_TOUR: {
    dev: true,
    testDev: true,
    testStaging: true,
    prod: true,
  },
  // https://gitlab.titanhq.com/groups/titanhq/dev/scrum/-/epics/58
  INCIDENTS_V3: {
    dev: false,
    testDev: true,
    testStaging: true,
    prod: false,
  },
  DASHBOARD_OVERVIEW_CUSTOMER: {
    dev: true,
    testDev: true,
    testStaging: false,
    prod: false,
  },
  // https://gitlab.titanhq.com/titanhq/dev/scrum/team-sherman/-/issues/1706
  PHS_CUSTOMER_SEND_TEST_LURE: {
    dev: true,
    testDev: true,
    testStaging: true,
    prod: false,
  },
  // https://gitlab.titanhq.com/titanhq/dev/scrum/team-sherman/-/issues/1628
  // https://gitlab.titanhq.com/titanhq/dev/scrum/team-sherman/-/issues/1828
  // https://gitlab.titanhq.com/titanhq/dev/scrum/team-sherman/-/issues/1829
  // https://gitlab.titanhq.com/titanhq/dev/scrum/team-sherman/-/issues/2077
  SAT_CONTENT_MANAGER: {
    dev: true,
    testDev: true,
    testStaging: true,
    prod: true,
  },
  // https://gitlab.titanhq.com/titanhq/dev/scrum/team-sherman/-/issues/1909
  SAT_CUSTOMER_REPORT_MANAGER: {
    dev: true,
    testDev: true,
    testStaging: true,
    prod: true,
  },
  // https://gitlab.titanhq.com/titanhq/dev/scrum/team-platfarmers/-/issues/2598
  // https://gitlab.titanhq.com/titanhq/dev/scrum/team-platfarmers/-/issues/2580
  // https://gitlab.titanhq.com/titanhq/dev/scrum/team-platfarmers/-/issues/2577
  // https://gitlab.titanhq.com/titanhq/dev/scrum/team-platfarmers/-/issues/2575
  // https://gitlab.titanhq.com/titanhq/dev/scrum/team-platfarmers/-/issues/2576
  // https://gitlab.titanhq.com/titanhq/dev/scrum/team-platfarmers/-/issues/2546
  // https://gitlab.titanhq.com/titanhq/dev/scrum/team-platfarmers/-/issues/2621
  // https://gitlab.titanhq.com/titanhq/dev/scrum/team-platfarmers/-/issues/2583
  // https://gitlab.titanhq.com/titanhq/dev/scrum/team-platfarmers/-/issues/2789
  // https://gitlab.titanhq.com/titanhq/dev/scrum/team-platfarmers/-/issues/2263
  // https://gitlab.titanhq.com/titanhq/dev/scrum/team-platfarmers/-/issues/2844
  // https://gitlab.titanhq.com/titanhq/dev/scrum/team-platfarmers/-/issues/2092
  // https://gitlab.titanhq.com/titanhq/dev/scrum/team-platfarmers/-/issues/2728
  // https://gitlab.titanhq.com/titanhq/dev/scrum/team-platfarmers/-/issues/2839
  RBAC: {
    dev: true,
    testDev: true,
    testStaging: true,
    prod: false,
  },
  // https://gitlab.titanhq.com/titanhq/dev/scrum/team-platfarmers/-/issues/2107
  ADMIN_SET_SYSTEM_ADMIN_ROLE: {
    dev: true,
    testDev: true,
    testStaging: true,
    prod: false,
  },
  // https://gitlab.titanhq.com/titanhq/dev/scrum/team-platfarmers/-/issues/1895
  NEW_EDIT_ADMIN_MODAL: {
    dev: true,
    testDev: true,
    testStaging: true,
    prod: false,
  },
  // https://gitlab.titanhq.com/titanhq/dev/scrum/team-hermes/-/issues/1956
  // https://gitlab.titanhq.com/titanhq/dev/scrum/team-hermes/-/issues/1957
  SEG: {
    dev: true,
    testDev: true,
    testStaging: true,
    prod: false,
  },
};
